module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quickChat",
    class: {
      open: _vm.open
    }
  }, [_vm._m(0), (_vm.open) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeModalFromClickOutside),
      expression: "closeModalFromClickOutside"
    }],
    staticClass: "discussionPane"
  }, [(_vm.show) ? _c('chat-conversation', {
    attrs: {
      "users": _vm.users
    }
  }) : _c('div', {
    staticClass: "waiting text-center text-muted"
  }, [(_vm.enoughInfo) ? [_vm._v(_vm._s(_vm.$t('chat.quickChat.waiting')) + " " + _vm._s(_vm._f("users")(_vm.users))), _c('br'), _c('br'), _vm._l((_vm.users), function(user) {
    return _c('vue-object-img', {
      key: user.id,
      attrs: {
        "object": user
      }
    })
  }), _c('br'), _c('br'), _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })] : [_vm._v(_vm._s(_vm.$t('chat.title'))), _c('br'), _c('br'), _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]], 2)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "closeQuickChat"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-052c2a2e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat/QuickChatConversation.vue
// module id = 1244
// module chunks = 1